module.exports = __webpack_public_path__ + "static/img/14000774.46f3df97.png";